export const HmrTestAsModule = ()=>{
    return 'HmrTestAsModule: ' + 'HMR_CHECK_0';
};
